import moment from 'moment';

const getFurthestJourneyStartDate = items => {
  if (items.length === 0) return moment().toISOString();
  const startsAt = items.map(item => (item.startsAt ? moment(item.startsAt) : moment()));
  return moment.max(startsAt).toISOString();
};

export default getFurthestJourneyStartDate;
